import { useEffect, useState } from 'react';

type TipState = { text: string; x: number; y: number; visible: boolean };

export function GlobalTooltip() {
  const [tip, setTip] = useState<TipState>({ text: '', x: 0, y: 0, visible: false });

  useEffect(() => {
    const findTipTarget = (el: EventTarget | null): HTMLElement | null => {
      let node = el as HTMLElement | null;
      while (node) {
        if (node instanceof HTMLElement && node.dataset && node.dataset.tooltip) return node;
        node = node.parentElement;
      }
      return null;
    };

    const onOver = (e: MouseEvent) => {
      const el = findTipTarget(e.target);
      if (!el) return;
      const text = el.dataset.tooltip || '';
      if (!text) return;
      setTip({ text, x: e.clientX + 12, y: e.clientY + 12, visible: true });
    };
    const onMove = (e: MouseEvent) => {
      if (!tip.visible) return;
      setTip(prev => ({ ...prev, x: e.clientX + 12, y: e.clientY + 12 }));
    };
    const onOut = () => {
      setTip(prev => ({ ...prev, visible: false }));
    };

    window.addEventListener('mouseover', onOver, { passive: true } as any);
    window.addEventListener('mousemove', onMove, { passive: true } as any);
    window.addEventListener('mouseout', onOut, { passive: true } as any);
    return () => {
      window.removeEventListener('mouseover', onOver as any);
      window.removeEventListener('mousemove', onMove as any);
      window.removeEventListener('mouseout', onOut as any);
    };
  }, [tip.visible]);

  if (!tip.visible) return null;
  return (
    <div
      style={{
        position: 'fixed',
        left: tip.x,
        top: tip.y,
        zIndex: 9999,
        pointerEvents: 'none',
        background: 'rgba(33,33,33,0.92)',
        color: '#fff',
        fontSize: 12,
        lineHeight: 1.2,
        padding: '6px 8px',
        borderRadius: 4,
        boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
      }}
      role="tooltip"
    >
      {tip.text}
    </div>
  );
}

